import { render, staticRenderFns } from "./ActionsButton.vue?vue&type=template&id=36e01140&scoped=true"
import script from "./ActionsButton.vue?vue&type=script&lang=js"
export * from "./ActionsButton.vue?vue&type=script&lang=js"
import style0 from "./ActionsButton.vue?vue&type=style&index=0&id=36e01140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e01140",
  null
  
)

export default component.exports